<template>
  <div class="app aside-menu-show">
    <aside class="aside-menu">
      <CRow class="nav nav-tabs p-0 p-md-3" role="tablist">
        <CCol
          sm="4"
          xl="2"
          class="nav-item mb-mobile-4"
          :class="activeTab == 'general-informations' ? 'active' : null"
          @click="changeTab('general-informations')"
        >
          <span>{{ $t("customer.label_customer_information") }}</span>
        </CCol>
        <CCol
          sm="4"
          xl="2"
          class="nav-item mb-mobile-4"
          :class="activeTab == 'contract' ? 'active' : null"
          @click="changeTab('contract')"
        >
          <span>{{ $t("customer.label_customer_cost") }}</span>
        </CCol>
        <CCol
          sm="4"
          xl="3"
          class="nav-item mb-mobile-4"
          :class="activeTab == 'customer-care' ? 'active' : null"
          @click="changeTab('customer-care')"
        >
          <span>{{ $t("customer.label_customer_user_information") }}</span>
        </CCol>
      </CRow>
      <!-- Tab panes-->
      <ValidationObserver v-slot="{ handleSubmit }" ref="formCustomer">
        <CForm @submit.prevent="handleSubmit(updateCustomer)">
          <div class="tab-content">
            <div
              class="tab-pane p-0 p-md-3"
              :class="activeTab == 'general-informations' ? 'active' : null"
              role="tabpanel"
            >
              <CInput type="hidden" v-model="customer.id" />
              <CRow class="mb-4 mb-mobile-3">
                <CCol sm="12" md="3" lg="3" xl="2">
                  <label>
                    {{ $t("customer.label_customer_company_name") }}
                    <span class="required">*</span>
                  </label>
                </CCol>
                <CCol sm="12" md="7" xl="5">
                  <ValidationProvider
                    rules="required|min:3|max:256"
                    v-slot="{ errors }"
                    :name="$t('customer.label_customer_company_name')"
                  >
                    <CInput type="text" v-model="customer.company_name" />
                    <span class="error-required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
              </CRow>

              <CRow class="mb-4 mb-mobile-3">
                <CCol sm="12" md="3" lg="3" xl="2">
                  <label>
                    {{ $t("customer.label_customer_abbreviations") }}
                    <span class="required">*</span>
                  </label>
                </CCol>
                <CCol sm="12" md="7" xl="5">
                  <ValidationProvider
                    rules="required|max:20"
                    v-slot="{ errors }"
                    :name="$t('customer.label_customer_abbreviations')"
                  >
                    <CInput type="text" v-model="customer.abbreviations" />
                    <span class="error-required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
              </CRow>

              <CRow class="mb-4 mb-mobile-3">
                <CCol sm="12" md="3" lg="3" xl="2">
                  <label>
                    {{ $t("customer.label_customer_investment") }}
                  </label>
                </CCol>
                <CCol sm="12" md="7" xl="5">
                  <ValidationProvider
                    rules="max:256"
                    v-slot="{ errors }"
                    :name="$t('customer.label_customer_investment')"
                  >
                    <CInput class type="text" v-model="customer.investment" />
                    <span class="placeholder">{{ $t("customer.money") }}</span>
                    <span class="error-required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
              </CRow>

              <CRow class="mb-4 mb-mobile-3">
                <CCol sm="12" md="3" lg="3" xl="2">
                  <label>{{ $t("customer.label_customer_rank") }}</label>
                </CCol>
                <CCol sm="12" md="7" xl="5">
                  <select
                    class="form-control form-group"
                    v-model="customer.rank"
                  >
                    <option
                      v-for="(option, index) in rank"
                      :key="index"
                      :value="option"
                      >{{ $t("customer.label_customer_rank") }}
                      {{ option }}</option
                    >
                  </select>
                </CCol>
              </CRow>

              <CRow class="mb-4 mb-mobile-3">
                <CCol sm="12" md="3" lg="3" xl="2">
                  <label>
                    {{ $t("customer.label_customer_shareholder") }}
                  </label>
                </CCol>
                <CCol sm="12" md="7" xl="5">
                  <ValidationProvider
                    rules="max:256"
                    v-slot="{ errors }"
                    :name="$t('customer.label_customer_shareholder')"
                  >
                    <CInput type="text" v-model="customer.shareholder" />
                    <span class="error-required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
              </CRow>

              <CRow class="mb-4 mb-mobile-3">
                <CCol sm="12" md="3" lg="3" xl="2">
                  <label>{{ $t("customer.label_customer_homepage") }}</label>
                </CCol>
                <CCol sm="12" md="7" xl="5">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('customer.label_customer_homepage')"
                  >
                    <CInput type="text" v-model="customer.website" />
                    <span class="error-required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
              </CRow>

              <CRow class="mb-4 mb-mobile-3">
                <CCol sm="12" md="3" lg="3" xl="2">
                  <label>
                    {{ $t("customer.label_customer_number_employee") }}
                  </label>
                </CCol>
                <CCol sm="12" md="7" xl="5">
                  <ValidationProvider
                    rules="max:256"
                    v-slot="{ errors }"
                    :name="$t('customer.label_customer_number_employee')"
                  >
                    <CInput type="text" v-model="customer.number_employee" />
                    <span class="error-required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
              </CRow>

              <CRow class="mb-4 mb-mobile-3">
                <CCol sm="12" md="3" lg="3" xl="2">
                  <label>{{
                    $t("customer.label_customer_company_description")
                  }}</label>
                </CCol>
                <CCol sm="12" md="7" xl="5">
                  <textarea
                    class="form-control"
                    rows="5"
                    v-model="customer.description"
                  />
                </CCol>
              </CRow>
            </div>
            <div
              class="tab-pane p-0 p-md-3"
              :class="activeTab == 'contract' ? 'active' : null"
              role="tabpanel"
            >
              <CRow>
                <CCol md="5" sm="12" class="employees-form-onsite">
                  <h5 class="onsite mt-mobile-0">
                    {{ $t("customer.label_customer_onsite") }}
                  </h5>
                  <h5>{{ $t("customer.semi_commissioned_contract") }}</h5>

                  <CRow class="mb-4 mb-mobile-3">
                    <CCol sm="12" xl="3">
                      <label>{{ $t("customer.label_onsite_leader") }}</label>
                    </CCol>
                    <CCol sm="12" xl="6">
                      <ValidationProvider
                        rules="numeric|max:20"
                        v-slot="{ errors }"
                        :name="$t('customer.label_onsite_leader')"
                      >
                        <CInput
                          type="text"
                          v-model="customer.contract_onsite_leader"
                        />
                        <span class="placeholder">{{
                          $t("customer.money")
                        }}</span>
                        <span class="error-required">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </CCol>
                  </CRow>

                  <CRow class="mb-4 mb-mobile-3">
                    <CCol sm="12" xl="3">
                      <label>{{ $t("customer.label_onsite_nember") }}</label>
                    </CCol>
                    <CCol sm="12" xl="6">
                      <ValidationProvider
                        rules="numeric|max:20"
                        v-slot="{ errors }"
                        :name="$t('customer.label_onsite_nember')"
                      >
                        <CInput
                          type="text"
                          v-model="customer.contract_onsite_member"
                        />
                        <span class="placeholder">{{
                          $t("customer.money")
                        }}</span>
                        <span class="error-required">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </CCol>
                  </CRow>
                  <h5>{{ $t("customer.contract") }}</h5>
                  <CRow class="mb-4 mb-mobile-3">
                    <CCol sm="12" xl="3">
                      <label>{{ $t("customer.label_onsite_leader") }}</label>
                    </CCol>
                    <CCol sm="12" xl="6">
                      <ValidationProvider
                        rules="numeric|max:20"
                        v-slot="{ errors }"
                        :name="$t('customer.label_onsite_leader')"
                      >
                        <CInput
                          type="text"
                          v-model="customer.lab_contract_onsite_leader"
                        />
                        <span class="placeholder">{{
                          $t("customer.money")
                        }}</span>
                        <span class="error-required">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </CCol>
                  </CRow>

                  <CRow class="mb-4 mb-mobile-3">
                    <CCol sm="12" xl="3">
                      <label>{{ $t("customer.label_onsite_nember") }}</label>
                    </CCol>
                    <CCol sm="12" xl="6">
                      <ValidationProvider
                        rules="numeric|max:20"
                        v-slot="{ errors }"
                        :name="$t('customer.label_onsite_nember')"
                      >
                        <CInput
                          type="text"
                          v-model="customer.lab_contract_onsite_member"
                        />
                        <span class="placeholder">{{
                          $t("customer.money")
                        }}</span>
                        <span class="error-required">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </CCol>
                  </CRow>
                </CCol>

                <CCol md="5" sm="12" class="employees-form-offshore">
                  <h5 class="onsite m-tablet-0">
                    {{ $t("customer.label_customer_offshore") }}
                  </h5>
                  <h5 class="label-text">
                    {{ $t("customer.semi_commissioned_contract") }}
                  </h5>
                  <CRow class="mb-4 mb-mobile-3">
                    <CCol sm="12" xl="3">
                      <label>{{ $t("customer.label_offshore_brse") }}</label>
                    </CCol>
                    <CCol sm="12" xl="6">
                      <ValidationProvider
                        rules="numeric|max:20"
                        v-slot="{ errors }"
                        :name="$t('customer.label_offshore_brse')"
                      >
                        <CInput
                          class
                          type="text"
                          v-model="customer.contract_offshore_brse"
                        />
                        <span class="placeholder">{{
                          $t("customer.money")
                        }}</span>
                        <span class="error-required">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </CCol>
                  </CRow>

                  <CRow class="mb-4 mb-mobile-3">
                    <CCol sm="12" xl="3">
                      <label>{{ $t("customer.label_offshore_se") }}</label>
                    </CCol>
                    <CCol sm="12" xl="6">
                      <ValidationProvider
                        rules="numeric|max:20"
                        v-slot="{ errors }"
                        :name="$t('customer.label_offshore_se')"
                      >
                        <CInput
                          class
                          type="text"
                          v-model="customer.contract_offshore_se"
                        />
                        <span class="placeholder">{{
                          $t("customer.money")
                        }}</span>
                        <span class="error-required">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </CCol>
                  </CRow>

                  <CRow class="mb-4 mb-mobile-3">
                    <CCol sm="12" xl="3">
                      <label>{{ $t("customer.label_offshore_tester") }}</label>
                    </CCol>
                    <CCol sm="12" xl="6">
                      <ValidationProvider
                        rules="numeric|max:20"
                        v-slot="{ errors }"
                        :name="$t('customer.label_offshore_tester')"
                      >
                        <CInput
                          class
                          type="text"
                          v-model="customer.contract_offshore_tester"
                        />
                        <span class="placeholder">{{
                          $t("customer.money")
                        }}</span>
                        <span class="error-required">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </CCol>
                  </CRow>
                  <CRow class="mb-4 mb-mobile-3">
                    <CCol sm="12" xl="3">
                      <label>{{ $t("customer.label_offshore_comtor") }}</label>
                    </CCol>
                    <CCol sm="12" xl="6">
                      <ValidationProvider
                        rules="numeric|max:20"
                        v-slot="{ errors }"
                        :name="$t('customer.label_offshore_comtor')"
                      >
                        <CInput
                          class
                          type="text"
                          v-model="customer.contract_offshore_comtor"
                        />
                        <span class="placeholder">{{
                          $t("customer.money")
                        }}</span>
                        <span class="error-required">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </CCol>
                  </CRow>
                  <CRow class="mb-4 mb-mobile-3">
                    <CCol sm="12" xl="3">
                      <h5 class="contract">{{ $t("customer.contract") }}</h5>
                    </CCol>
                    <CCol sm="12" xl="6">
                      <ValidationProvider
                        rules="numeric|max:20"
                        v-slot="{ errors }"
                        :name="$t('customer.contract')"
                      >
                        <CInput
                          class
                          type="text"
                          v-model="customer.lab_contract_offshore"
                        />
                        <span class="placeholder">{{
                          $t("customer.money")
                        }}</span>
                        <span class="error-required">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </div>
            <div
              class="tab-pane p-0 p-md-3"
              :class="activeTab == 'customer-care' ? 'active' : null"
              role="tabpanel"
            >
              <h5 class="mt-mobile-0">{{ $t("customer.label_customer") }}</h5>
              <div class="list-customer-information">
                <div
                  v-for="(item_employee,
                  index) in customer.customer_responsibilities"
                  :key="index"
                  class="customer-infomation mb-md-5 mb-mobile-2"
                >
                  <div v-if="item_employee.type == 1">
                    <CRow class="mb-4 mb-mobile-3 align-items-center">
                      <CCol sm="12" md="3" lg="3" xl="2">
                        <label>
                          {{ $t("customer.label_customer_name") }}
                        </label>
                      </CCol>
                      <CCol
                        :col="checkTypeLength(1) ? 11 : 12"
                        sm="12"
                        md="7"
                        xl="5"
                      >
                        <CInput type="text" v-model="item_employee.name" />
                      </CCol>
                      <span
                        @click="deleteInformation(index)"
                        v-if="checkTypeLength(1)"
                      >
                        <CIcon name="cilTrash" class="delete-btn" />
                      </span>
                    </CRow>
                    <CRow class="mb-4 mb-mobile-3">
                      <CCol sm="12" md="3" lg="3" xl="2">
                        <label>
                          {{ $t("customer.label_customer_location") }}
                        </label>
                      </CCol>
                      <CCol
                        :col="checkTypeLength(1) ? 11 : 12"
                        sm="12"
                        md="7"
                        xl="5"
                      >
                        <CInput
                          class="-select"
                          type="text"
                          v-model="item_employee.position"
                        />
                      </CCol>
                    </CRow>
                  </div>
                </div>
                <div class="btn-add-new">
                  <label @click="addInformation(1)">{{
                    $t("customer.label_add_infor")
                  }}</label>
                </div>
              </div>
              <h5>{{ $t("customer.label_customer_fabbi_japan") }}</h5>
              <div class="customers-care-jp">
                <div
                  v-for="(item_employee,
                  index) in customer.customer_responsibilities"
                  :key="index"
                >
                  <div v-if="item_employee.type == 2">
                    <CRow class="mb-4 mb-mobile-3 align-items-center">
                      <CCol sm="12" md="3" lg="3" xl="2">
                        <label>
                          {{ $t("customer.label_customer_name") }}
                        </label>
                      </CCol>
                      <CCol
                        :col="checkTypeLength(2) ? 11 : 12"
                        sm="12"
                        md="7"
                        xl="5"
                      >
                        <CInput type="text" v-model="item_employee.name" />
                      </CCol>
                      <span
                        @click="deleteInformation(index)"
                        v-if="checkTypeLength(2)"
                      >
                        <CIcon name="cilTrash" class="delete-btn" />
                      </span>
                    </CRow>
                  </div>
                </div>
                <div class="btn-add-new">
                  <label @click="addInformation(2)">{{
                    $t("customer.label_add_infor")
                  }}</label>
                </div>
              </div>
              <h5>{{ $t("customer.label_customer_fabbi") }}</h5>
              <div class="customers-care-hn">
                <div
                  v-for="(item_employee,
                  index) in customer.customer_responsibilities"
                  :key="index"
                >
                  <div v-if="item_employee.type == 3">
                    <CRow class="mb-4 mb-mobile-3 align-items-center">
                      <CCol sm="12" md="3" lg="3" xl="2">
                        <label>
                          {{ $t("customer.label_customer_name") }}
                        </label>
                      </CCol>
                      <CCol
                        :col="checkTypeLength(3) ? 11 : 12"
                        sm="12"
                        md="7"
                        xl="5"
                      >
                        <CInput type="text" v-model="item_employee.name" />
                      </CCol>
                      <span
                        @click="deleteInformation(index)"
                        v-if="checkTypeLength(3)"
                      >
                        <CIcon name="cilTrash" class="delete-btn" />
                      </span>
                    </CRow>
                  </div>
                </div>
                <div class="btn-add-new">
                  <label @click="addInformation(3)">{{
                    $t("customer.label_add_infor")
                  }}</label>
                </div>
              </div>
            </div>
            <CRow>
              <CCol md="12" sm="12" class="button p-3 button-submit-mobile">
                <CButton type="submit" size="sm" class="m-2 btn-submit">{{
                  $t("button.label_action_create")
                }}</CButton>
              </CCol>
            </CRow>
          </div>
        </CForm>
      </ValidationObserver>
    </aside>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Customer",
  metaInfo() {
    return {
      title: this.$t("page_title.page_customer_update"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      isValid: true,
      activeTab: "general-informations"
    };
  },

  created() {
    this.editCustomer();
    if (this.$route.params.tab) {
      this.activeTab = this.$route.params.tab;
    }
  },

  computed: {
    ...mapGetters({
      customer: "customer/customerEdit",
      rank: "commons/rank"
    })
  },

  methods: {
    ...mapActions("customer", ["edit"]),
    filterData(type) {
      if (this.customer) {
        return this.customer.customer_responsibilities.filter(
          item => item.type === type
        );
      }
    },
    async editCustomer() {
      let id = await this.$route.params.id;
      if (id) {
        await this.edit(id);
      }
    },
    validateForm() {
      let fields = [];
      this.isValid = true;
      for (let employee of this.customer.customer_responsibilities) {
        fields.push(employee);
      }
      for (let field of fields) {
        switch (field.type) {
          case 1:
            if (!field.name || !field.position) {
              this.isValid = false;
              return;
            }
            break;
          case 2:
            if (!field.name) {
              this.isValid = false;
              return;
            }
            break;
          case 3:
            if (!field.name) {
              this.isValid = false;
              return;
            }
            break;
        }
      }
    },
    async updateCustomer() {
      let form = JSON.parse(JSON.stringify(this.customer));
      delete form.employees;
      form = {
        ...form,
        responsibilityCustomer: [],
        responsibilityFabbiJapan: [],
        responsibilityFabbi: []
      };
      let employeesType_1 = this.filterData(1);
      let employeesType_2 = this.filterData(2);
      let employeesType_3 = this.filterData(3);
      for (let i = 0; i < employeesType_1.length; i++) {
        let data = {
          name: employeesType_1[i].name,
          employee_position: employeesType_1[i].position
        };
        form.responsibilityCustomer.push(data);
      }
      for (let i = 0; i < employeesType_2.length; i++) {
        let data = {
          name: employeesType_2[i].name
        };
        form.responsibilityFabbiJapan.push(data);
      }
      for (let i = 0; i < employeesType_3.length; i++) {
        let data = {
          name: employeesType_3[i].name
        };
        form.responsibilityFabbi.push(data);
      }
      let check = await this.$refs.formCustomer.validate();
      if (check && this.isValid) {
        await this.$store.dispatch("customer/update", form).then(() => {
          let message = [this.$t("customer.popup.update_customer_success")];
          message.forEach(message => {
            this.$bvToast.toast(message, {
              title: "",
              noCloseButton: false,
              autoHideDelay: 2000,
              appendToast: true,
              toaster: "b-toaster-top-center",
              variant: "success",
              noFade: false,
              solid: true
            });
          });
          setTimeout(() => {
            this.$router.push({ path: `/customers` });
          }, 1000);
        });
      }
    },
    changeTab(name) {
      this.activeTab = name;
    },
    addInformation(type) {
      this.customer.customer_responsibilities.push({
        customer_id: null,
        position: null,
        type
      });
    },
    checkTypeLength(type) {
      return (
        this.customer.customer_responsibilities.filter(
          item => item.type === type
        ).length > 1
      );
    },
    deleteInformation(index) {
      this.customer.customer_responsibilities.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.aside-menu {
  margin-left: 150px;
}
.nav-tabs {
  border: none;
  font-size: 1rem;
}
.nav-item {
  color: #858585;
  cursor: pointer;
}
.nav-item.active span {
  color: #032641;
  display: inline-block;
  border-bottom: 2px solid black;
  padding-bottom: 2px;
  font-weight: bold;
}
.form-group {
  margin-bottom: 0;
}
h5 {
  margin: 30px 0;
  font-weight: bold;
}
label {
  color: #385368;
}
.required {
  color: #ff1a1a;
}
.onsite,
.offshore {
  color: #f6922d;
}
.placeholder {
  position: absolute;
  right: 25px;
  color: #b3b3b3;
  top: 7px;
}
.error-required {
  color: #ff1a1a;
}
.contract {
  margin: 0px;
}
.btn-add-new label {
  color: #f6ab5f;
  font-size: 1rem;
  cursor: pointer;
}
.btn-submit {
  background-color: #b4daf3;
  width: 215px;
  height: 40px;
  font-size: 0.75rem;
  font-weight: 700;
}
.delete-btn {
  color: red;
}
@media screen and (max-width: 1024px) {
  .aside-menu {
    margin-left: 0.2rem;
  }
  .button-submit-mobile {
    text-align: center;
    padding: 0 0 1rem 0 !important;
    margin: 15px 0;
  }
  .mb-mobile-4 {
    margin-bottom: 1.5rem;
  }
  .mb-mobile-2 {
    margin-bottom: 1rem;
  }
  .mt-mobile-0 {
    margin-top: 0;
  }
  .mt-mobile-2 {
    margin-top: 1rem;
  }
  .mb-mobile-3 {
    margin-bottom: 1rem !important;
  }
  .mt-mobile-4 {
    margin-top: 1.5rem;
  }
  .btn-add-new label {
    margin-left: 0;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .m-tablet-0 {
    margin: 0;
  }
}
</style>
